// FadeInSection.jsx
import React, { useRef, useState, useEffect } from "react";

const FadeInSection = ({ children, id }) => {
  const [isVisible, setVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => setVisible(entry.isIntersecting));
    });
    const { current } = domRef;
    if (current) observer.observe(current);
    return () => observer.unobserve(current);
  }, []);

  return (
    <div
      id={id}
      ref={domRef}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0px)" : "translateY(20px)",
        transition: "all 0.8s ease-out",
        padding: "60px 20px",
      }}
    >
      {children}
    </div>
  );
};

export default FadeInSection;
